import { useState, useCallback } from "react";
import api from "../utils/api"; // 🔥 ekledik

export function useSegmentPresets(userId, channelId) {
  const [presets, setPresets] = useState([]);

  const loadPresets = useCallback(async () => {
    if (!userId || !channelId) return;

    try {
      const res = await api.get(
        `/get-selections?uid=${userId}&cid=${channelId}`
      );

      const data = res.data;
      setPresets(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("loadPresets error:", err);
      setPresets([]);
    }
  }, [userId, channelId]);

  const savePreset = async (name, state) => {
    if (!userId || !channelId) {
      console.error("Missing uid or cid", { userId, channelId });
      return;
    }

    try {
      const params = new URLSearchParams({
        uid: userId,
        cid: channelId,
        name,
        sm: state.startTime,
        em: state.endTime,
        interval: state.interval,
        day: state.selectedWeekdays.join("-"),
      });

      await api.get(`/save-selections?${params.toString()}`); // 🔥 değişti

      await loadPresets();
    } catch (err) {
      console.error("savePreset error:", err);
    }
  };

  const deletePreset = async (presetId) => {
    if (!userId || !presetId) return;

    try {
      await api.get(
        `/remove-selection?uid=${userId}&sid=${presetId}`
      ); // 🔥 değişti

      await loadPresets();
    } catch (err) {
      console.error("deletePreset error:", err);
    }
  };

  return {
    presets,
    loadPresets,
    savePreset,
    deletePreset,
  };
}